import { ColumnFilter as ColumnOption } from "../../types/PageFilterTypes";
import { ColumnType, TableCellType } from "../../models/tableModels";

export const MY_FUNDS_BASE_COLUMNS: ColumnOption[] = [
  { displayValue: "Fund Name", key: "portfolio_index_id", fixed: "left" },
  { displayValue: "Currency", key: "currency" },
  { displayValue: "Fund AUM", key: "fund_aum" },
  { displayValue: "Added On", key: "added_on" },
  { displayValue: "Pathway", key: "pathway" },
];

export const MY_FUNDS_COLUMN_TYPES: ColumnType[] = [
  { type: TableCellType.NUMBER, columnKey: "fund_aum", isComparative: false },
  { type: TableCellType.FUND_LINK, columnKey: "portfolio_index_id" },
  { type: TableCellType.TEXT, columnKey: "currency" },
  { type: TableCellType.TEXT, columnKey: "added_on" },
  { type: TableCellType.PATHWAY, columnKey: "pathway" },
  { type: TableCellType.PERCENTAGE, columnKey: "emissions_growth" },
  { type: TableCellType.DELETE_PORTFOLIO, columnKey: "delete" },
];

export const DELETE_COLUMN: ColumnOption = {
  displayValue: "Remove",
  key: "delete",
  fixed: "right",
};
export const DEFAULT_COMPARABLE_COLUMNS: TableCellType[] = [
  TableCellType.NUMBER,
  TableCellType.PERCENTAGE,
];

export const FUND_KEY_PREFIX = "fund_";

export const PORTFOLIO_INDEX_ID_COLUMN = "portfolio_index_id";
